import { useEffect, useState } from "react";
import { Button, Space } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { loadedInitSelector } from "appredux/selectors";
import { isTokenExist } from "utils/cookies";
import { getMobileOperatingSystem } from "utils/helper";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.kledo.crm";

// Banner ajakan install app. Muncul berdasarkan OS device (userAgent),
// bukan lebar layar. iOS/App Store di-skip dulu — hanya Android.
// Ephemeral: dismiss hanya berlaku selama sesi, muncul lagi saat reload.
const InstallPromptWrapper = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const loadedInit = useSelector(loadedInitSelector);

  // Selama splash "Menyiapkan ruang kerja" tampil (sudah login tapi data init
  // belum termuat), banner ditahan dulu — sama seperti kondisi PageLoader.
  const isPreparingWorkspace = isTokenExist() && !loadedInit;

  useEffect(() => {
    if (getMobileOperatingSystem() === "android") {
      setVisible(true);
    }
  }, []);

  if (!visible || isPreparingWorkspace) return null;

  return (
    <div
      className="hide-on-print"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 16,
        padding: 24,
        borderTop: "1px solid #f0f0f0",
        backgroundColor: "#FFFFFF",
        zIndex: 1000,
      }}
    >
      <h5 style={{ textAlign: "center", margin: 0 }}>
        {t("notification.crm_id_is_now_on_google_play")}
      </h5>
      <Space>
        <Button
          type="primary"
          target="_blank"
          rel="noopener noreferrer"
          href={PLAY_STORE_URL}
        >
          {t("notification.install_now")}
        </Button>
        <Button onClick={() => setVisible(false)}>
          {t("notification.later")}
        </Button>
      </Space>
    </div>
  );
};

export default InstallPromptWrapper;
